import React from 'react';
import { SAFETY } from '../mock';

export default function Safety() {
  return (
    <section id="safety" className="bg-white py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FF6A1A]">SAFETY FIRST</span>
          <h2 className="mt-3 text-[34px] md:text-[46px] font-semibold tracking-[-0.02em] text-[#0f0f10]">
            Built for safety
          </h2>
          <p className="mt-4 text-[15px] md:text-[16px] text-[#6b6b70] leading-relaxed">
            Every ride, every driver, every time — we have engineered safety into every tap.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5 md:gap-6">
          {SAFETY.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="group bg-[#f7f7f5] hover:bg-[#0f0f10] rounded-3xl p-7 md:p-8 transition-colors duration-300 cursor-default"
              >
                <div className="w-12 h-12 rounded-2xl bg-[#FF6A1A] text-white grid place-items-center">
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 text-[22px] font-semibold text-[#0f0f10] group-hover:text-white transition-colors tracking-[-0.01em]">
                  {s.title}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-[#6b6b70] group-hover:text-white/70 transition-colors">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
